'use client';
import { IconButton } from "@mui/material";
import React, { useLayoutEffect, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import cssStyles from "@/app/components/shopify_cart/shopify_cart.module.scss";

interface QuantityBoxProps {
	decrement: any;
	increment: any;
	incrementByInput: any;
	id: any;
	variant: any;
	quantity: any;
	availabilityCount: any;
}

const QuantityBox: React.FC<QuantityBoxProps> = ({ decrement, increment, incrementByInput, id, quantity, variant, availabilityCount }: any) => {
	const [inputValue, setInputValue] = useState(quantity);
	const [showMsg, setShowMsg] = useState(false);

	useLayoutEffect(() => {
		setInputValue(quantity);
		if (quantity >= availabilityCount) {
			setShowMsg(true);
		} else {
			setShowMsg(false);
		}
	}, [quantity, availabilityCount])

	return (<>
		{showMsg ? (
			<div
				style={{
					color: "#d32f2f",
					fontSize: "12px",
					fontWeight: 500,
					whiteSpace: "nowrap",
					marginBottom: "4px",
					textAlign: "center",
					lineHeight: 1.2,
				}}
			>
				Only {availabilityCount} available
			</div>
		) : null}
		<div className={cssStyles["cart-item__quantity"]} style={{ height: "40px", boxSizing: "border-box" }}>
			<IconButton color="secondary"
				aria-label="quantity button minus" onClick={(e: any) => {
					if (quantity >= availabilityCount) {
						setShowMsg(true);
					}
					decrement(id, quantity, e)
				}}>
				<RemoveIcon className={cssStyles["icon"]} />
			</IconButton>
			<span className="quantity__count" >
				<input className={cssStyles["border-on-focus"]} value={inputValue}
					style={{ borderColor: (inputValue > availabilityCount) ? "red" : "black" }}
					onBlur={(e) => {
						let value = parseInt(e.target.value);
						if (value >= availabilityCount) {
							value = availabilityCount
							setInputValue(value);
						} else {
							setShowMsg(false);
						}
						incrementByInput(id, variant?.sku, e)
						setInputValue(value);
					}}
					onChange={(e) => {
						const val = e.target.value;
						if (val === "") {
							setInputValue("");
						} else if (!isNaN(parseInt(val)) && parseInt(val) > 0) {
							if (val > availabilityCount) {
								setShowMsg(true);
							}
							setInputValue(parseInt(val));
						}
					}} />
			</span>
			<IconButton color="primary" aria-label="quantity button add" onClick={(e: any) => {
				if (quantity >= availabilityCount) {
					setShowMsg(true);
				} else {
					setShowMsg(false);
				}
				increment(id, quantity, variant?.sku, e)
			}}>
				<AddIcon className={cssStyles["icon"]} />
			</IconButton>
		</div></>)
};

export default QuantityBox;
